/* ==========================================================================
  main.js
========================================================================== */

'use strict';

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/**
 * Scroll to top
 */
function animateToTop(e) {
  e.preventDefault();
  var scrollToTop = window.setInterval(function() {
      var pos = window.pageYOffset;
      if ( pos > 0 ) {
          window.scrollTo( 0, pos - 80 );
      } else {
          window.clearInterval( scrollToTop );
      }
  }, 2);
}

const counterUp = window.counterUp.default

const callback = entries => {
	entries.forEach( entry => {
		const el = entry.target
		if ( entry.isIntersecting && ! el.classList.contains( 'is-visible' ) ) {
			counterUp( el, {
				duration: 2000,
				delay: 16,
			} )
			el.classList.add( 'is-visible' )
		}
	} )
}

const IO = new IntersectionObserver( callback, { threshold: 1 } )

const elementList = document.querySelectorAll( '.keyfigure' );

elementList.forEach(function(element) {
  IO.observe( element );
});


